import { render, staticRenderFns } from "./Dimensoes.vue?vue&type=template&id=79a02e3d"
import script from "./Dimensoes.vue?vue&type=script&lang=js"
export * from "./Dimensoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports